import AccessLog from './access_log';

export default AccessLog;
